var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLastMessageSurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#828283",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.96 0H1.62C.729 0 0 .729 0 1.62v11.34c0 .891.729 1.62 1.62 1.62h11.34c.891 0 1.62-.729 1.62-1.62V1.62c0-.891-.729-1.62-1.62-1.62zm-8.1 11.34H3.24V5.67h1.62v5.67zm3.24 0H6.48v-8.1H8.1v8.1zm3.24 0H9.72V8.1h1.62v3.24z",
    transform: "translate(-271 -534) translate(-12 465) translate(283.72 69.72)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastMessageSurvey);
export default __webpack_public_path__ + "static/media/lastMessageSurvey.32cc9c0c0bdd7b32ec88e5cfe6b87dca.svg";
export { ForwardRef as ReactComponent };